import { render, staticRenderFns } from "./LongBox.vue?vue&type=template&id=b13283c8&scoped=true"
import script from "./LongBox.vue?vue&type=script&lang=js"
export * from "./LongBox.vue?vue&type=script&lang=js"
import style0 from "./LongBox.vue?vue&type=style&index=0&id=b13283c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13283c8",
  null
  
)

export default component.exports